import React from 'react';
const benefits = [{
  icon: '📚',
  title: '5 Tomi Completi',
  desc: "Dalla cellula all'ecologia. Un percorso strutturato per ogni anno scolastico."
}, {
  icon: '🧪',
  title: 'Laboratori Guidati',
  desc: 'Esperimenti pratici con protocolli chiari, materiali necessari e schede di osservazione.'
}, {
  icon: '🧠',
  title: 'Mappe Concettuali',
  desc: 'Schemi visivi pronti per DSA e per il ripasso rapido di ogni macro-argomento.'
}, {
  icon: '📋',
  title: 'Verifiche e Test',
  desc: 'Batterie di test a risposta multipla, domande aperte e griglie di valutazione.'
}, {
  icon: '🎨',
  title: 'Attività Interattive',
  desc: 'Giochi didattici, flashcards e progetti di gruppo per imparare divertendosi.'
}, {
  icon: '🌍',
  title: 'Biologia Moderna',
  desc: 'Contenuti aggiornati su genetica, biotecnologie e sostenibilità ambientale.'
}];
export function BenefitsSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <div className="text-center mb-14" data-id="element-3">
          <h2 className="text-3xl sm:text-5xl font-montserrat font-black text-text-main mb-4 tracking-tight" data-id="element-4">
            🎁 Cosa Contiene BIOLOGIA PRONTA™?
          </h2>
          <p className="text-text-sec text-base sm:text-lg max-w-2xl mx-auto" data-id="element-5">
            Tutto ciò di cui hai bisogno in un unico pacchetto digitale premium.
            Sei pilastri didattici per trasformare le tue lezioni.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-id="element-6">
          {benefits.map((benefit, i) => <div key={i} className="bg-bg-alt p-8 rounded-3xl border border-border-light shadow-lg flex flex-col gap-4 hover:-translate-y-1 hover:border-primary/40 transition-all duration-300 relative overflow-hidden group" data-id="element-7">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-8"></div>

              <div className="w-14 h-14 rounded-2xl bg-bg-dark border border-primary/20 flex items-center justify-center text-3xl mb-2 relative z-10 shadow-inner" data-id="element-9">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-text-main relative z-10" data-id="element-10">
                {benefit.title}
              </h3>
              <p className="text-text-sec leading-relaxed text-base relative z-10" data-id="element-11">
                {benefit.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}